export default __webpack_public_path__ + "static/media/icon-steering-wheel.8f29fc53.svg";